import { t as themeResolver } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export interface StatIndicatorStyledProps {
  color: string;
}
export const StatIndicatorStyled = styled.div<StatIndicatorStyledProps>`
  ${({ theme, color }) => css`
    height: ${theme.spacings[500]};
    width: ${theme.spacings[500]};
    background-color: ${themeResolver(`colors.${color}`)};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${theme.spacings[400]};
  `}
`;

export const ToolOrderCatalogItemStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
